import React from "react";
import Swal from "sweetalert2";
import axios from "../../../axios/axios";
import UpdateCountry from "./../UpdateCountry/UpdateCountry";

const Country = ({ country, index, isUpdate, setIsUpdate }) => {
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`/countries/${id}`);
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
          setIsUpdate(!isUpdate);
        } catch (error) {
          Swal.fire("Error!");
        }
      }
    });
  };

  return (
    <tr>
      <th>{index + 1}</th>
      <th>{country?.name}</th>
      <td>
        <img
          style={{ height: "32px", width: "32px", borderRadius: "5px" }}
          src={country?.flag_url}
          alt={index + 1}
        />
      </td>
      <td style={{ minWidth: "100px" }}>
        <UpdateCountry
          country={country}
          index={index}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
        />
        <button
          style={{
            backgroundColor: "red",
            border: "none",
            borderRadius: "5px",
            marginLeft: "5px",
          }}
          onClick={() => handleDelete(country?.id)}
        >
          <i
            style={{
              color: "white",
              padding: "7px 3px",
              fontSize: "15px",
            }}
            className="fa fa-trash-o"
          ></i>
        </button>
      </td>
    </tr>
  );
};

export default Country;
